import { EventEmitter, Injectable } from "@angular/core";
import * as signalR from "@microsoft/signalr";
import { environment } from "../../../environments/environment";
import { LocalStorage } from "../local-storage";
import { SessionService } from "../session.service";
import { ModalAuthService } from "../ux/modal-auth.service";
import { AuthResponse } from "../../models/auth-response";
import { UserHttpClientService } from "src/app/data/user-http-client.service";

@Injectable({
  providedIn: "root"
})
export class LoginHub {
  public hubConnection: signalR.HubConnection;

  public retryLoginEventEmitter: EventEmitter<boolean>;
  public loginRejectEventEmitter: EventEmitter<boolean>;

  constructor(
    private ls: LocalStorage,
    private session: SessionService,
    private AuthmodalService: ModalAuthService,
    private userService: UserHttpClientService
  ) {
    this.retryLoginEventEmitter = new EventEmitter<boolean>();
    this.loginRejectEventEmitter = new EventEmitter<boolean>();
  }

  public buildConnection() {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.backendBaseUrl}/ws-auth-hub`)
      .withAutomaticReconnect()
      .build();
  }

  public startConnection() {
    this.hubConnection.start().then(() => {
      this.registerSignalEvents();
    });
  }

  private registerSignalEvents() {
    this.hubConnection.on("onLoginWentBad", () => {
      this.retryLoginEventEmitter.emit(true);
    });

    // Todo: Duhet pare kur nuk pranon user,  * no toast
    this.hubConnection.on("onLoginRejected", () => {
      this.loginRejectEventEmitter.emit(true);
    });

    this.hubConnection.on("onLoginSuccess", (data: { accessToken: string, expiresIn: number }) => {
      // this.ls.set("auth", JSON.stringify(res));
      this.ls.set(
        "auth",
        JSON.stringify({
          access_token: data.accessToken,
          expires_in: data.expiresIn
        })
       );

      this.userService.getUserDetails().subscribe(data => {})

      this.session.login();

      this.hubConnection.stop();
      this.AuthmodalService.close();
    });
  }
}
